<template>
  <div class="p-grid p-col-12">
      <div class="p-col-12 p-md-12 p-lg-12 no-padding-margin-bottom-top">
          <card class="p-col-12" :header="$t('protocol.tab-financial.financial-information')" >

              <div class="p-col-6">
                  <Button class="p-button-outlined p-mr-2 p-mb-2 p-button p-component" @click.prevent="newEntry('in')">
                    <span class="p-button-label">
                      <i class="fa-solid fa-plus p-mr-2"></i>{{$t('protocol.tab-financial.new-cash-in')}}
                    </span>
                  </Button>
                  <Button class="p-button-outlined p-button-danger p-mr-2 p-mb-2 p-button p-component" @click.prevent="newEntry('out')">
                    <span class="p-button-label">
                      <i class="fa-solid fa-minus p-mr-2"></i>{{$t('protocol.tab-financial.new-cash-out')}}
                    </span>
                  </Button>
                  <Button class="p-button-outlined p-button-info p-mr-2 p-mb-2 p-button p-component" @click.prevent="newEntry('DISCOUNT')">
                    <span class="p-button-label">
                      <i class="fa-solid fa-plus p-mr-2"></i>{{$t('protocol.tab-financial.new-discount')}}
                    </span>
                  </Button>
              </div>

              <hr style="width: 100%;"/>

              <DataTable v-if="entries.length > 0" :value="entries" class="p-datatable-customers" :rows="5" style="margin-bottom: 20px" :paginator="false">
                  <Column :header="$t('protocol.tab-financial.user')" headerClass="p-col-12 p-md-2 p-lg-2">
                      <template #body="slotProps">
                          <image-from-server class="avatar p-mr-2 float-left" :src="slotProps.data.user.avatar" />
                          {{ slotProps.data.user.name }} <br />
                          <span class="small">{{ $d(new Date(slotProps.data.created), 'long') }}</span>
                      </template>
                  </Column>
                  <Column :header="$t('protocol.tab-financial.observation')" headerClass="p-col-12 p-md-2 p-lg-2">
                      <template #body="slotProps">
                          {{ slotProps.data.observation ? slotProps.data.observation : '-' }}
                      </template>
                  </Column>
                  <Column :header="$t('protocol.tab-financial.modal-entry.client')" headerClass="p-col-12 p-md-3 p-lg-3">
                      <template #body="slotProps">
                          {{ slotProps.data.client ? slotProps.data.client.name : '-' }}
                      </template>
                  </Column>
                  <Column :header="$t('protocol.tab-financial.type')" headerClass="p-col-12 p-md-2 p-lg-2">
                      <template #body="slotProps">
                          {{ getTypeEntryLabel(slotProps.data.typeEntry) }}
                      </template>
                  </Column>
                  <Column :header="$t('protocol.tab-financial.value')" headerClass="p-col-12 p-md-3 p-lg-3">
                      <template #body="slotProps">
                          <span :class="slotProps.data.typeEntry === 'DISCOUNT' ? 'color-primary bold' : slotProps.data.valueEntry > 0 ? 'color-success bold' : 'coff-input-error bold'">{{ $n(slotProps.data.valueEntry, 'currency') }}</span>
                      </template>
                  </Column>
                  <Column :header="$t('protocol.tab-financial.actions')" headerClass="p-col-12 p-md-1 p-lg-1">
                      <template #body="slotProps">
                          <a class="cursor-pointer" @click.prevent="newEntry(null, {...slotProps['data'] })"><i class="p-ml-2 pi pi-pencil small" :title="$t('protocol.tab-financial.edit')"/></a>
                          <a class="cursor-pointer" @click.prevent="remove(slotProps.data.id)"><i class="p-ml-2 pi pi-times small" :title="$t('protocol.tab-financial.delete')"/></a>
                      </template>
                  </Column>
              </DataTable>

              <Message v-else class="p-col-12" severity="warn" style="white-space: pre-line;">{{$t('protocol.tab-financial.no-cash-entries')}}</Message>

              <div class="p-col-12 p-md-6 p-lg-4 p-ml-auto">
                  <table class="p-ml-auto table-mr bold p-text-right" style="min-width: 100%">
                      <tr >
                          <td><span>{{ $t('protocol.tab-financial.total-in') }}</span></td>
                          <td style="min-width: 60px;">{{ protocolValues.totalReceived > 0 ? $n(protocolValues.totalReceived, 'currency') : '-'}}</td>
                      </tr>
                      <tr>
                          <td><span>{{ $t('protocol.tab-financial.protocol-price') }}</span></td>
                          <td>{{ protocolValues.totalPrice > 0 ? $n(protocolValues.totalPrice, 'currency') : '-'}}</td>
                      </tr>
                      <tr>
                          <td><span>{{ $t('protocol.tab-financial.protocol-price-with-discount') }}</span></td>
                          <td>{{ protocolValues.totalWithDiscount > 0 ? $n(protocolValues.totalWithDiscount, 'currency') : '-'}}</td>
                      </tr>
                      <tr>
                          <td colspan="2" >
                              <hr style="width: 60%; float: right;" />
                          </td>
                      </tr>
                      <tr v-if="protocolValues.balance >= 0" :class="protocolValues.balance > 0 ? 'coff-input-error' : 'color-primary'">
                          <td><span>{{ $t('protocol.tab-financial.balance-to-in') }}</span></td>
                          <td>{{ protocolValues.balance > 0 ? $n(protocolValues.balance, 'currency') : '-' }}</td>
                      </tr>
                      <tr v-else class="color-success">
                          <td><span>{{ $t('protocol.tab-financial.change') }}</span></td>
                          <td>{{ $n(protocolValues.balance * -1, 'currency') }}</td>
                      </tr>
                  </table>
              </div>

          </card>
      </div>
  </div>
</template>

<script>

import ProtocolFinancialBusiness from "@/business/ProtocolFinancialBusiness";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import ImageFromServer from "@/components/image/ImageFromServer";
import DialogService from "@/business/ModalBusiness";
import ModalAddEntry from "@/viewer/protocol/tabs/financial/ModalAddEntry.vue";
import { _getTypeEntryLabel } from "@/constants/TypeOfEntry";
import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation";

export default {
      name: "TabFinancialProtocol",
      components: {ImageFromServer},

      props:{
            protocol: {type: Object, default: () => {return {}}},
      },

      async mounted() {
          await this.loadEntries();
          await this.loadProtocolValues();
      },

      data(){
            return{
                entries: [],
                protocolValues: {},
                getTypeEntryLabel: _getTypeEntryLabel,
            }
      },

      methods:{

          async loadEntries() {
              const response = await ProtocolFinancialBusiness.getAll(this.protocol.id).catch((e) => ToastMessageBusiness.showError(e.message));
              if(response){
                this.entries = response;
              }
          },

          async loadProtocolValues() {
              const response = await ProtocolFinancialBusiness.getProtocolValues(this.protocol.id).catch((e) => ToastMessageBusiness.showError(e.message));
              if(response){
                  this.protocolValues = response;
              }
          },

          async newEntry(typeEntry, editEntry = {}) {
            if(editEntry.id) {
                const response = await ProtocolFinancialBusiness.getById(editEntry.id).catch((e) => ToastMessageBusiness.showError(e.message));
              if(response){
                  editEntry = response;
              }
            }
            if (editEntry.valueEntry && editEntry.valueEntry.indexOf('-') > -1) {
                editEntry.valueEntry = editEntry.valueEntry.replace('-', '');
                typeEntry = 'out';
            }
            if(editEntry.typeEntry === 'DISCOUNT') {
                typeEntry = 'DISCOUNT';
            }
            const entryToSave = await DialogService.openModal(ModalAddEntry, {entry: editEntry, protocolId: this.protocol.id, typeEntry});
            if(entryToSave){
                if (typeEntry === 'out') {
                    entryToSave.valueEntry = '-' + entryToSave.valueEntry;
                }
                entryToSave.protocol = {id: this.protocol.id};
                const saved = await ProtocolFinancialBusiness.save(entryToSave, this.protocol.id, editEntry.id).catch((e) => ToastMessageBusiness.showError(e.message));
                if (saved) {
                    await this.loadEntries();
                    await this.loadProtocolValues();
                }
            }
          },

          async remove(entryId) {
              if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
                  const response = await ProtocolFinancialBusiness.delete(this.protocol.id, entryId).catch((e) => ToastMessageBusiness.showError(e.message));
                  if(response){
                      await this.loadEntries();
                      await this.loadProtocolValues();
                      ToastMessageBusiness.showSuccess();
                  }
              }
          }
      }

}
</script>

<style scoped>

  .table-mr {
      margin-right: 30%;
  }

  .no-padding-margin-bottom-top {
    padding-top: 0 !important;
    margin-top: 0 !important;
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }

  .force-mb-0 {
    margin-bottom: 0rem !important;
  }

  .force-mt-0 {
    margin-bottom: 0rem !important;
  }

  .avatar {
    width: 55px;
    border-radius: 80px;
  }

  .cursor-pointer {
    cursor: pointer !important;
  }

</style>